<template>
  <div class="home container">
    <div class="pt-6" style="width: 230px; margin: 0 auto;">
      <img class="pt-6" width="240" :src="require(`@/assets/honors_spade-14.png`)" />
      <h1 class="is-size-5">Kanto Bridge</h1>
      <p class="mt-2">Room: </p>
      <input width="200" class="input" type="text" v-model="roomId">
      <button class="button is-info mt-2" v-on:click="start()">Join Room</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: function() {
    return {
      roomId:  Math.random().toString(36).substring(7)
    }
  },
  methods: {
    start() {
      this.$router.push({ path: `/room/${this.roomId}` });
    },
  },
};
</script>
